// components/AboutSectionLayout.jsx
import React from "react";
import styles from "../styles/AboutSection.module.css";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function AboutSectionLayout({ data }) {
  const navigate = useNavigate();

  return (
    <AnimatePresence mode="wait">
      <motion.section
        key={data.title}   // IMPORTANT: forces re-animation on change
        className={styles.section}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        id="about"
      >
        <div className={styles.container}>
          
          <div className={styles.left}>
            <motion.img
              src={data.image}
              alt={data.title}
              initial={{ scale: 1.05, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
            />
          </div>

          <div className={styles.right}>
            <span>{data.subtitle}</span>

            <h2>{data.title}</h2>

            {data.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}

            <a  href={data.ctaLink} >
              {data.ctaText}
            </a>
          </div>

        </div>
      </motion.section>
    </AnimatePresence>
  );
}